import React, { useState } from 'react';
import { PageHeader, Page, PageContent, Box, Text, Tab, Tabs, Heading, Paragraph, Image } from 'grommet';
import { ValueStreamsGrid } from './ValueStreamsGrid';
import { MapTabContent } from '../../components/MapTabContent';
//import { useHeaderHeight } from '../../utils/HeaderHeightContext';

export const ValueStreamsHome = () => {
  //const { headerHeight } = useHeaderHeight(); // Get headerHeight from context
  const [activeSampleTab, setActiveSampleTab] = useState(0);

  return (
    <Page flex="grow"
          background="background-back">

      <Box background="url('/images/hpe-hq-top.jpg')" height="200px" margin={{ top: 'none'}}>
        <Box margin={{ top: 'none', left: 'large' }}>
          <PageHeader pad={{ top: '15px', bottom: '15px' }} 
            title={<Text color="white" size="xxlarge" weight="bolder" style={{fontWeight: 'bold'}}>OneGW Value Stream</Text>} 
            subtitle={'Understanding GW\'s diverse value stream from edge to cloud.'}
            style={{ color: 'white' }}
            size='medium'/>
        </Box>                  
      </Box>

      <PageContent flex="grow" width="80%">
        <ValueStreamsGrid isVerticalGrid = {true} isGridExpanded = {false} />

        <Heading size="medium" margin={{ top: 'large' }}>Tab View Example</Heading>
        <Tabs activeIndex={activeSampleTab} onActive={setActiveSampleTab} justify="start">
            <Tab title="Buildings">
                <MapTabContent>
                    <Paragraph margin="none">Coming soon...</Paragraph>
                </MapTabContent>
            </Tab>
            <Tab title="Network">
                <MapTabContent>
                    <Text size="small" margin="none">Temp illustrative placeholder:</Text>
                    <Box direction="row" width="100%" pad={{ top: '0px' }} flex="grow">
                        <Image fit="cover" src="images/example-saas-product-view.png" />
                    </Box>
                </MapTabContent>
            </Tab>
            <Tab title="Fire">
                <MapTabContent>
                    <Paragraph margin="none">Coming soon...</Paragraph>
                </MapTabContent>
            </Tab>
            <Tab title="Security">
                <MapTabContent>
                    <Paragraph margin="none">Coming soon...</Paragraph>
                </MapTabContent>
            </Tab>
            <Tab title="Alerts">
                <MapTabContent>
                    <Paragraph margin="none">Coming soon...</Paragraph>
                </MapTabContent>
            </Tab>
        </Tabs>

      </PageContent>

    </Page>
  );
};